export interface Column1ViewModelState {
  genericDocTaxListingState: any;
  }
  
  export const initialState: Column1ViewModelState = {
  genericDocTaxListingState: null,
  };